import { render, staticRenderFns } from "./identifiers.vue?vue&type=template&id=54370038&"
import script from "./identifiers.vue?vue&type=script&lang=js&"
export * from "./identifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports